<div class="container-fluid px-5 py-3">
    <div class="d-flex justify-content-between pb-2">
        <span class="text-blue font-weight-bold">
            <h3 class="my-2" translate>sales.search.title</h3>
        </span>
    </div>

    <!-- ******************************************************
    ********************* Search Form *********************
    ****************************************************** -->
    <form [formGroup]="searchForm">
        <div class="input-group mb-2">

            <!-- technical point -->
            <div class="input-group-prepend">
                <span class="input-group-text" translate>sales.search.techPoint</span>
            </div>
            <select class="custom-select" aria-describedby="techPointMobileAppId"
                formControlName="techPointMobileAppId" style="max-width: 200pt;">
                <!-- Withheld from an employee: their own point is the only one they may search. -->
                <option *ngIf="!hasTechnicalPoint" value="" translate>placeholder.select</option>
                <option *ngFor="let point of technicalPoints" [value]="point.mobileAppId">{{point.shortName}}</option>
            </select>

            <!-- reg number -->
            <div class="input-group-prepend ml-2">
                <span class="input-group-text" translate>sales.search.regNumber</span>
            </div>
            <input type="text" class="form-control d-inline" formControlName="regNumber"
                style="max-width: 150pt; text-transform: uppercase;" (keyup.enter)="search()">

            <!-- date range -->
            <div class="input-group-prepend ml-2">
                <span class="input-group-text" id="dateFrom" translate>sales.search.dateFrom</span>
            </div>
            <input class="form-control d-inline" aria-describedby="dateFrom" style="max-width: 130pt;"
                formControlName="dateFrom" ngbDatepicker #d1="ngbDatepicker" readonly>
            <button class="btn btn-outline-secondary fa fa-calendar" (click)="d1.toggle()" type="button"
                style="height: 38px; border-radius: 0;"></button>

            <div class="input-group-prepend ml-2">
                <span class="input-group-text" id="dateTo" translate>sales.search.dateTo</span>
            </div>
            <input class="form-control d-inline" aria-describedby="dateTo" style="max-width: 130pt;"
                formControlName="dateTo" ngbDatepicker #d2="ngbDatepicker" readonly>
            <button class="btn btn-outline-secondary fa fa-calendar" (click)="d2.toggle()" type="button"
                style="height: 38px; border-radius: 0;"></button>

            <!-- actions -->
            <div class="input-group-prepend ml-2">
                <div style="display: flex;">
                    <button class="btn btn-outline-success" style="border-radius: 0;" type="button"
                        [disabled]="loadPdfOrExcel" (click)="search()" translate>button.search</button>
                    <button class="btn btn-outline-danger ml-2" style="border-radius: 0;" type="button"
                        [disabled]="loadPdfOrExcel" (click)="clearSearch()" translate>button.clear</button>
                    <button class="btn btn-outline-success ml-2" style="border-radius: 0;" type="button"
                        routerLink="/add-edit-sales"
                        *ngIf="perms.hasAccess(perms.CAN_ADD_EDIT_SALE)" translate>button.add</button>

                    <ng-container *ngIf="!loadPdfOrExcel; else pleaseWaitExport">
                        <i class="fa fa-file-excel-o fa-2x" style="margin-left: 10px; margin-top: 2px; cursor: pointer;"
                            data-toggle="tooltip" data-placement="bottom" title="{{'button.excel' | translate}}"
                            (click)="exportExcel()"></i>
                        <i class="fa fa-file-pdf-o fa-2x" style="margin-left: 5px; margin-top: 2px; cursor: pointer;"
                            data-toggle="tooltip" data-placement="bottom" title="{{'button.pdf' | translate}}"
                            (click)="exportPDF()"></i>
                    </ng-container>
                    <ng-template #pleaseWaitExport>
                        <span class="pleaseWait ml-2" translate>placeholder.wait</span>
                    </ng-template>
                </div>
            </div>

        </div>
    </form>

    <!-- ******************************************************
    *********************** Results ***********************
    ****************************************************** -->
    <div [hidden]="!dataLoaded">
        <div class="table-responsive">
            <table class="table table-bordered table-striped w-100">
                <thead>
                    <tr>
                        <th style="width: 12%;" scope="col" translate>sales.search.techPoint</th>
                        <th style="width: 11%;" scope="col" translate>sales.search.date</th>
                        <th style="width: 9%;" scope="col" translate>sales.search.regNumber</th>
                        <th style="width: 8%;" scope="col" translate>sales.search.rvsCategory</th>
                        <th style="width: 22%;" scope="col" translate>sales.search.services</th>
                        <th style="width: 22%;" scope="col" translate>sales.search.items</th>
                        <th style="width: 11%;" scope="col" translate>sales.search.promoCode</th>
                        <th style="width: 5%;" scope="col" class="text-center" translate>sales.search.actions</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let sale of content">
                        <td>{{sale.techPointName}}</td>
                        <td>{{sale.date}}</td>
                        <td>{{sale.regNumber}}</td>
                        <td>{{sale.rvsCategoryCode}}</td>
                        <td>{{sale.serviceNames}}</td>
                        <td>{{sale.itemNames}}</td>
                        <td>{{sale.promoCodes}}</td>
                        <td class="text-center py-2">
                            <!-- An invoiced sale can still be edited; the tooltip says the issued
                                 document will not follow the change. -->
                            <button class="btn btn-sm btn-success" type="button"
                                *ngIf="perms.hasAccess(perms.CAN_ADD_EDIT_SALE)"
                                routerLink="/add-edit-sales"
                                [queryParams]="{id: sale.id, hasInvoice: sale.hasInvoice}"
                                data-toggle="tooltip" data-placement="bottom"
                                title="{{(sale.hasInvoice ? 'sales.search.editInvoiced' : 'button.edit') | translate}}">
                                <i class="fa fa-pencil fa-lg"></i>
                            </button>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>

        <div class="alert alert-info" *ngIf="content && content.length === 0" translate>sales.search.none</div>

        <!-- ******************************************************
        ********************** Pagination *********************
        ****************************************************** -->
        <div class="paging-wrapper d-flex justify-content-between">
            <select class="pagination-size custom-select" [(ngModel)]="sortingPaging.pageSize"
                [ngModelOptions]="{standalone: true}" (change)="onPageSizeChange($event)">
                <option *ngFor="let item of pageSizeOptions; let i = index" [value]="pageSizeOptions[i]">
                    {{pageSizeOptions[i]}} {{'paging.itemsPerPage' | translate}}
                </option>
            </select>
            <ngb-pagination class="pagination-control"
                [(page)]="sortingPaging.pageNumber" [pageSize]="sortingPaging.pageSize"
                [collectionSize]="sortingPaging.totalElements" [boundaryLinks]="true"
                [maxSize]="maxSize" (pageChange)="pageChanged($event)">
            </ngb-pagination>
            <span class="pagination-index border center">
                {{sortingPaging.fromRow}} - {{sortingPaging.toRow}} / {{sortingPaging.totalElements}}
            </span>
        </div>
    </div>

    <ng-container *ngIf="dataLoaded; else dataLoadingTemplate"></ng-container>
</div>

<ng-template #dataLoadingTemplate>
    <div *ngIf="errorMessage$ | async as errorMessage; else dataSpinner">
        <div class="alert alert-danger">{{errorMessage}}</div>
        <div class="d-flex justify-content-center"><em class="fa fa-refresh" (click)="reload()"></em></div>
    </div>
    <ng-template #dataSpinner>
        <div class="d-flex justify-content-center">
            <div class="spinner-border" role="status"><span class="sr-only">Loading...</span></div>
        </div>
    </ng-template>
</ng-template>
